import Library from '../../views/Library/Library.view';

export default Library;